import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { ESTADOS_PRODUCCION } from "../../../../../../../../../utility/constants";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const ActionsContent = ({ estado, item, setProduccionSeleccionada, EliminarProduccion }) => {
    if (estado === ESTADOS_PRODUCCION.PENDIENTE) {
        return (
            <div className="table-actions">
                <Link to={`/produccion-v2/editar-produccion/${item.id}`}>
                    <img
                        src={editarIcon}
                        alt="Editar"
                        className="action_img"
                        title="Editar"
                    />
                </Link>
                <img
                    src={eliminarIcon}
                    alt="Eliminar"
                    className="action_img"
                    title="Eliminar"
                    onClick={() => EliminarProduccion(item.id)}
                />
            </div>
        );
    } else if (estado === ESTADOS_PRODUCCION.EN_PROCESO) {
        return (
            <div className="table-actions">
                <Link to={`/produccion-v2/editar-produccion/${item.id}`}>
                    <img
                        src={editarIcon}
                        alt="Editar"
                        className="action_img"
                        title="Editar"
                    />
                </Link>
                <img
                    src={verIcon}
                    alt="Ver"
                    className="action_img"
                    title="Ver"
                    onClick={() => setProduccionSeleccionada(item)}
                />
            </div>
        );
    } else if (estado === ESTADOS_PRODUCCION.FINALIZADA) {
        return (
            <div className="table-actions">
                <img
                    src={verIcon}
                    alt="Ver"
                    className="action_img"
                    title="Ver"
                    onClick={() => setProduccionSeleccionada(item)}
                />
            </div>
        );
    } else {
        return null;
    }
};
